/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для пользователя
   */
  app.User = app.Model.extend({

    urlRoot: app.entryScriptName + '/api/v3/user',

    parseDate: function () {
      var dateAr;
      var birth_date = this.get('birth_date');

      this.birth_year = '';
      this.birth_month = '';
      this.birth_day = '';

      if (!birth_date) {
        return;
      }

      dateAr = birth_date.split('-');

      this.birth_year = dateAr[0];
      this.birth_month = dateAr[1];
      this.birth_day = dateAr[2];
    },

    /**
     * Сохранение айди организатора СП
     * @param organizerId
     * @param options опции запроса на сохранение
     */
    saveJpOrganizer: function (organizerId, options) {
      app.helpers.CookieHelper.setCookie('my_jp_organizer', organizerId, {
        expires: moment().add(1, 'hours').toString(),
        path: '/'
      });

      if (this.get('id')) {
        var newUserData = {
          selected_jp_organizer_id: organizerId
        };
        if (options && !options.error) {
          options.error = function () {
            app.helpers.ErrorHelper.globalValidationError([{
              message: ''
            }], 'При сохранении выбранного организатора совместной покупки');
          };
        }

        this.save(newUserData, options);
      } else if (options && _.isFunction(options.success)) {
        options.success(this, null, options);
      }
    },
    /**
     * Список приложений (messengers) привязанных к телефону.
     * @returns {Array}
     */
    phoneApps: function () {
      var apps = [];
      if (this.get('phone')) {
        this.get('is_whatsapp') && apps.push('WhatsApp');
        this.get('is_viber') && apps.push('Viber');
        this.get('is_telegram') && apps.push('Telegram');
      }

      return apps;
    },
    /**
     * Номер телефона в человекочитаемом формате.
     * @returns {*|String}
     */
    phoneHumanFormat: function () {
      return app.helpers.PhoneHelper.getFormatedPhoneNumber(this.get('phone'));
    }
  });

})();

}.call(window));